module.exports = __webpack_public_path__ + "static/img/7.5bd8532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/7.jpg
// module id = 7Q4y
// module chunks = 0